import { appEnv } from 'shared/envs'
import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { httpWithChallenge } from '~/domains/platform/infra/http/http-with-challenge'

export type ConfirmAffiliationConsentRequest = {
  code: string
  state: string
}

export type ConfirmAffiliationConsentResponse = {
  affiliationId?: string
}

type UseConfirmAffiliationConsentParams = {
  paymentProfileId: string
}

export function useConfirmAffiliationConsent({ paymentProfileId }: UseConfirmAffiliationConsentParams) {
  return (body: ConfirmAffiliationConsentRequest) =>
    httpWithChallenge({
      config: {
        url: `/v1/payment-profile/${paymentProfileId}/affiliations/consents/confirm`,
        method: 'POST',
        data: { ...body, state: appEnv.isProduction() ? body.state : `${body.state}Staging` }
      },
      client: httpClientVendasCoreBff
    })
}
